import { CompletarDatosAutorizarTransaccionesComponent } from "../components/asuntos externos/autorizarTransacciones/completar-datos-autorizar-transacciones/completar-datos-autorizar-transacciones.component";
import { ValidarTransaccionesComponent } from "../components/asuntos externos/autorizarTransacciones/validar-transacciones/validar-transacciones.component";
import { VerificarEmisionChequeGerenciaComponent } from "../components/asuntos externos/autorizarTransacciones/verificar-emision-cheque-gerencia/verificar-emision-cheque-gerencia.component";
import { VerificarTransferenciaInterbancariaComponent } from "../components/asuntos externos/autorizarTransacciones/verificar-transferencia-interbancaria/verificar-transferencia-interbancaria.component";
import { DatosCandidatoComponent } from "../components/asuntos externos/investigacion-empleo/datos-candidato/datos-candidato.component";
import { VerificacionCandidatoComponent } from "../components/asuntos externos/investigacion-empleo/verificacion-candidato/verificacion-candidato.component";
import { VerificacionSaimeComponent } from "../components/asuntos externos/investigacion-empleo/verificacion-saime/verificacion-saime.component";
import { AsesoriaGerenteServiciosComponent } from "../components/asuntos externos/rol-guardia/asesoria-gerente-servicios/asesoria-gerente-servicios.component";
import { CasoRoboHurtoComponent } from "../components/asuntos externos/rol-guardia/caso-robo-hurto/caso-robo-hurto.component";
import { CrearSolicitudAlertaComponent } from "../components/asuntos externos/rol-guardia/crear-solicitud-alerta/crear-solicitud-alerta.component";
import { ElevaAdministracionSegurosComponent } from "../components/asuntos externos/rol-guardia/eleva-administracion-seguros/eleva-administracion-seguros.component";
import { InformePreliminarComponent } from "../components/asuntos externos/rol-guardia/informe-preliminar/informe-preliminar.component";
import { PerquisaRolGuardiaComponent } from "../components/asuntos externos/rol-guardia/perquisa-rol-guardia/perquisa-rol-guardia.component";
import { PersonalInternoInvolucradoRolComponent } from "../components/asuntos externos/rol-guardia/personal-interno-involucrado-rol/personal-interno-involucrado-rol.component";
import { CompletarValidacionDocumentoComponent } from "../components/asuntos externos/validacion-documento/completar-validacion-documento/completar-validacion-documento.component";
import { SeguimientoDocumentoIrregularComponent } from "../components/asuntos externos/validacion-documento/seguimiento-documento-irregular/seguimiento-documento-irregular.component";
import { ValidacionDeDocumentoComponent } from "../components/asuntos externos/validacion-documento/validacion-de-documento/validacion-de-documento.component";
import { CrearSolicitudValidacionRefComponent } from "../components/asuntos externos/validacion-referencia/crear-solicitud-validacion-ref/crear-solicitud-validacion-ref.component";
import { ValidacionReferenciaComponent } from "../components/asuntos externos/validacion-referencia/validacion-referencia/validacion-referencia.component";

export const COMPONENTS = [
    {
      name: 'Completar Datos de Solicitud (Autorización de transacciones)',
      value: 'CompletarDatosSolicitudAutorizacionTransacciones',
      component: CompletarDatosAutorizarTransaccionesComponent,
      caso: 'autorizacion de transacciones'
    },
    {
      name: 'Verificar Transferencia interbancaria',
      value: 'VerificarTransferenciaInterbancaria',
      component: VerificarTransferenciaInterbancariaComponent,
      caso: 'autorizacion de transacciones'
    },
    {
      name: 'Verificar Emision de Cheque de Gerencia',
      value: 'VerificarEmisionChequeGerencia',
      component: VerificarEmisionChequeGerenciaComponent,
      caso: 'autorizacion de transacciones'
    },
    {
      name: 'Validar Transacciones',
      value: 'ValidarTransacciones',
      component: ValidarTransaccionesComponent,
      caso: 'autorizacion de transacciones'
    },
    {
      name: 'Completar Validacion Documento',
      value: 'CompletarDatosValidacionDocumento',
      component: CompletarValidacionDocumentoComponent,
      caso: 'validacion de documentos'
    },
    {
      name: 'Validacion De Documento',
      value: 'ValidacionDeDocumentos',
      component: ValidacionDeDocumentoComponent,
      caso: 'validacion de documentos'
    },
    {
      name: 'Seguimiento Documento Irregular',
      value: 'SeguimientoDocumentoIrregular',
      component: SeguimientoDocumentoIrregularComponent,
      caso: 'validacion de documentos'
    },
    {
      name: 'Crear la solicitud de validacion de referencias',
      value: 'CrearSolicitudValidacionReferencias',
      component: CrearSolicitudValidacionRefComponent,
      caso: 'validacion de referencia'
    },
    {
      name: 'Validacion de Referencias',
      value: 'ValidacionReferencias',
      component: ValidacionReferenciaComponent,
      caso: 'validacion de referencia'
    },
    {
      name: 'Crear la solicitud de Alerta',
      value: 'CrearSolicitudAlerta',
      component: CrearSolicitudAlertaComponent,
      caso: 'rol de guardia'
    },
    {
      name: 'Pesquisa',
      value: 'Pesquisa',
      component: PerquisaRolGuardiaComponent,
      caso: 'rol de guardia'
    },
    {
      name: 'Informe Preliminar',
      value: 'InformePreliminar',
      component: InformePreliminarComponent,
      caso: 'rol de guardia'
    },
    {
      name: 'Personal Interno Involucrado',
      value: 'PersonalInternoInvolucrado',
      component: PersonalInternoInvolucradoRolComponent,
      caso: 'rol de guardia'
    },
    {
      name: 'Asesoria al Gerente de Servicios',
      value: 'AsesoriaGerenteServicios',
      component: AsesoriaGerenteServiciosComponent,
      caso: 'rol de guardia'
    },
    {
      name: 'Caso de Robo o Hurto (Remitir a Consultoría Jurídica)',
      value: 'CasoRoboHurto',
      component: CasoRoboHurtoComponent,
      caso: 'rol de guardia'
    },
    {
      name: 'Eleva el caso al área de Administración y Seguros',
      value: 'ElevaAdministraciónSeguros',
      component: ElevaAdministracionSegurosComponent,
      caso: 'rol de guardia'
    },
    {
      name: 'Datos de Candidato',
      value: 'DatosCandidato',
      component: DatosCandidatoComponent,
      caso: 'investigacion pre empleo'
    },
    {
      name: 'Verificacion Saime',
      value: 'VerificacionSaime',
      component: VerificacionSaimeComponent,
      caso: 'investigacion pre empleo'
    },
    {
      name: 'Verificacion Candidato',
      value: 'VerificacionCandidato',
      component: VerificacionCandidatoComponent,
      caso: 'investigacion pre empleo'
    },

  ]